import { chooseTemplate } from '../../../../../common/user/user.roles';
import guest from './successfulSubmit.guest.html';
import defaultTemplate from './successfulSubmit.html';

export const template = chooseTemplate({
  guest,
  defaultTemplate
});
